const ButtonLeagues = () => (
  <span className="tokens-league-btn">
    <strong>Token Leagues</strong>
    { ' (soon)' }
  </span>
);

export default ButtonLeagues;
